
    import Vue from "vue";
    import Component from "vue-class-component";
    import { Prop } from "vue-property-decorator";
    import { OfficialSignatureApiModel } from "@/api-client";

    @Component
    export default class OfficialSignature extends Vue {
        @Prop({ required: true })
        signature!: OfficialSignatureApiModel;
        
        // Signer name can be missing on migrated documents. Documents issued in MIS will all have signer name.
        get signerNameIsAvailable(): boolean {
            return !!this.signature.signerFullName;
        }
    }
